import { startGetEstatusAsistencia } from "../actions/detalleActions";
import { types } from "../types/types";

const init = {
  folderPagina: "proveedor",
  asistenciaDetalle: {},
  asistencia: {},
  aceptacionNotificacion: {},
  distanceInKmBetweenPlacesByApiGoogle: 0,
  loadingDetalle: true,
  sucursalesByServicio: [],
  asistenciaHistorial: [],
  proveedorGeos: {},
  proveedorCostos: {},
  proveedorPagoDirecto: "",
  historialAsignacion: [],
  loadingHistorialAsignacion: false,
  asistenciasByValidador1: [],
  asistenciaFiles: [],
  talleres: [],
  corralones: [],
  loadingDatosDrawer: false,
  estatusAsistencia:0
};
export const detalleReducer = (state = init, action) => {
  switch (action.type) {
    case types.setEstatusAsistencia:
      return {
        ...state,
        estatusAsistencia: action.payload,
      };
    case types.setLoadingDatosDrawer:
      return {
        ...state,
        loadingDatosDrawer: action.payload,
      };
    case types.storeCorralones:
      return {
        ...state,
        corralones: action.payload,
      };
    case types.storeTalleres:
      return {
        ...state,
        talleres: action.payload,
      };
    case types.setLoadingHistorialAsignacion:
      return {
        ...state,
        loadingHistorialAsignacion: action.payload,
      };
    case types.saveDistance:
      return {
        ...state,
        distanceInKmBetweenPlacesByApiGoogle: action.payload,
      };
    case types.storeAsistenciaFiles:
      return {
        ...state,
        asistenciaFiles: action.payload,
      };

    case types.clearProveedorCostos:
      return {
        ...state,
        proveedorCostos: {},
        proveedorPagoDirecto: "",
      };

    case types.storeAsistenciasByValidador1:
      return {
        ...state,
        asistenciasByValidador1: action.payload,
      };
    case types.storeHistorialAsignacion:
      return {
        ...state,
        historialAsignacion: action.payload,
      };

    case types.storeAsistenciaHistorial:
      return {
        ...state,
        asistenciaHistorial: action.payload,
      };
    case types.storeProveedorCostos: {
      return {
        ...state,
        proveedorCostos: action.payload,
      };
    }

    case types.setProveedorPagoDirecto:
      return {
        ...state,
        proveedorPagoDirecto: action.payload,
      };

    case types.clearProveedorGeos:
      return {
        ...state,
        proveedorGeos: {},
      };

    case types.setProveedorGeos:
      return {
        ...state,
        proveedorGeos: action.payload,
      };

    case types.storeSucursalesByServicio:
      return {
        ...state,
        sucursalesByServicio: action.payload,
      };

    case types.setLoadingDetalle:
      return {
        ...state,
        loadingDetalle: action.payload,
      };
    case types.storeAsistencia:
      return {
        ...state,
        asistencia: action.payload,
      };
    case types.storeAceptacionNotificacion:
      return {
        ...state,
        aceptacionNotificacion: action.payload,
      };
    case types.clearAceptacionNotificacion:
      return {
        ...state,
        aceptacionNotificacion: {},
      };
    case types.setFolderPagina:
      return {
        ...state,
        folderPagina: action.payload,
      };
    case types.setAsistenciaDetalle:
      return {
        ...state,
        asistenciaDetalle: action.payload,
      };

    default:
      return state;
  }
};
